import { ErrorTranslations } from "../models/error-translaction-model"

export const enUS: ErrorTranslations = {
  required: "*Mandatory field",
  validateNoQuotes: "Single quotes and double quotes are not allowed.",
  ruleNameRequired: "Rule Name is a required field",
};
